import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

import { AmpPlugin, DateTime, LockPlugin, RangePlugin, easepick } from '@easepick/bundle'
import apiFetch from '@wordpress/api-fetch'

export default class Home {
    constructor() {
        Home.sliderHeader()
        Home.sliderAgenda()
        Home.bookingBG()
        Home.bookingForm()
        Home.bookingSelect()
        Home.engineFormSubmit()
        Home.engineDate()
        Home.agendaEngine()
        Home.instaWall()
    }

    static async sliderHeader() {
        const selector = '[data-element="header-home-slider"]'

        if ($(selector).length) {
            $(selector).each(async function () {
                await Swiper.create(this, {
                    slidesPerView: 1,
                    mousewheel: {
                        forceToAxis: true,
                    },
                    autoplay: {
                        delay: 7000,
                    },
                    speed: 600,
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    lazy: true,
                    watchSlidesProgress: true,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.strate-header__slider__arrows__next',
                        prevEl: '.strate-header__slider__arrows__prev',
                    },
                    grabCursor: true,
                })
            })
        }
    }

    static async sliderAgenda() {
        const selector = '[data-element="agenda-home-slider"]'
        const startDate = $('[data-element="start-date"]')

        if ($(selector).length) {
            //Init slider
            const swiperAgenda = await Swiper.create(selector, {
                slidesPerView: 1,
                mousewheel: {
                    forceToAxis: true,
                },
                speed: 500,
                lazy: true,
                watchSlidesProgress: true,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.strate-agenda__slider__arrows__next',
                    prevEl: '.strate-agenda__slider__arrows__prev',
                },
                grabCursor: true,
                breakpoints: {
                    650: {
                        spaceBetween: 20,
                    },
                    1000: {
                        spaceBetween: 0,
                    },
                },
            })

            //Init start date
            const startDay = $(selector)
                .find('.swiper-slide-active [data-element="start-day"]')
                .text()
            const startMonth = $(selector)
                .find('.swiper-slide-active [data-element="start-month"]')
                .text()
            startDate.html(
                `<span class="start-day">${startDay}</span><span class="start-month">${startMonth}</span>`,
            )

            //On change start date
            swiperAgenda.on('transitionEnd', () => {
                const startDay = $(selector)
                    .find('.swiper-slide-active [data-element="start-day"]')
                    .text()
                const startMonth = $(selector)
                    .find('.swiper-slide-active [data-element="start-month"]')
                    .text()
                startDate.html(
                    `<span class="start-day">${startDay}</span><span class="start-month">${startMonth}</span>`,
                )
            })
        }

        if ($('body').hasClass('eco-mode-active') && startDate.length > 0) {
            //Init start date
            const strateAgenda = '.strate-agenda'
            const startDay = $(strateAgenda)
                .find('.iris-card__content__metas-event__start [data-element="start-day"]')
                .text()
            const startMonth = $(strateAgenda)
                .find('.iris-card__content__metas-event__start [data-element="start-month"]')
                .text()
            startDate.html(
                `<span class="start-day">${startDay}</span><span class="start-month">${startMonth}</span>`,
            )
        }
    }

    static bookingSelect() {
        if ($('.strate-booking').length > 0) {
            const trigger = $('[data-trigger="label-select"]')
            const backgrounds = $('[data-background]')

            if (trigger.length > 0) {
                import(
                    '@iris.interactive/handcook/public/scripts/components/tab/tab.component' /* webpackChunkName: "scripts/hc_tab" */
                ).then(({ HcTab }) => {
                    trigger.on('input', (e) => {
                        const val = $(e.currentTarget).val()
                        HcTab.show(`#${val}`)
                    })
                })
            }

            trigger.on('change', function () {
                const dataTriggerBg = $(this).find('option:selected').attr('data-trigger-bg')
                const dataElementBg = $(`[data-background="${dataTriggerBg}"]`)
                backgrounds.removeClass('bg-active')
                dataElementBg.addClass('bg-active')
            })
        }
    }

    static bookingBG() {
        if ($('.strate-booking').length > 0) {
            const trigger = $('[data-hc-tab]')
            const backgrounds = $('[data-background]')

            trigger.on('click', function () {
                const dataTriggerBg = $(this).attr('data-trigger-bg')
                const dataElementBg = $(`[data-background="${dataTriggerBg}"]`)
                backgrounds.removeClass('bg-active')
                dataElementBg.addClass('bg-active')
            })
        }
    }

    static bookingForm() {
        if ($('.strate-booking').length > 0) {
            const form = $('[data-element="engine-form"]')
            form.each(function () {
                const thisForm = $(this)
                thisForm.find('[data-element="engine-type"]').on('change', () => {
                    const action = thisForm
                        .find('[data-element="engine-type"] option:selected')
                        .attr('data-action')
                    thisForm.attr('action', action)
                })
            })
        }
    }

    static engineDate() {
        if ($('[id^="engine-booking-start-date"]').length > 0) {
            let startDate
            let endDate = null

            const inputStartDateAccomodation = document.getElementById(
                'engine-booking-start-date--accomodation',
            )
            if (inputStartDateAccomodation) {
                new easepick.create({
                    element: inputStartDateAccomodation,
                    css: [
                        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
                        IRISCollectionCustomer.styleCustomerEasepick,
                    ],
                    setup(picker) {
                        picker.on('select', (e) => {
                            startDate = e.detail.start.format('YYYY-MM-DD')
                            endDate = e.detail.start.format('YYYY-MM-DD')
                        })
                    },
                    inline: false,
                    calendars: 1,
                    zIndex: 12345,
                    lang: 'fr-FR',
                    AmpPlugin: {
                        resetButton: true,
                    },
                    LockPlugin: {
                        minDate: new Date(),
                    },
                    RangePlugin: {
                        tooltip: false,
                        elementEnd: document.getElementById(
                            'engine-booking-end-date--accomodation',
                        ),
                    },
                    plugins: [LockPlugin, AmpPlugin, RangePlugin],
                })
            }

            const inputStartDateActivity = document.getElementById(
                'engine-booking-start-date--activity',
            )

            if (inputStartDateActivity) {
                new easepick.create({
                    element: inputStartDateActivity,
                    css: [
                        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
                        IRISCollectionCustomer.styleCustomerEasepick,
                    ],
                    setup(picker) {
                        picker.on('select', (e) => {
                            startDate = e.detail.start.format('YYYY-MM-DD')
                            endDate = e.detail.start.format('YYYY-MM-DD')
                        })
                    },
                    inline: false,
                    calendars: 1,
                    zIndex: 12345,
                    lang: 'fr-FR',
                    AmpPlugin: {
                        resetButton: true,
                    },
                    LockPlugin: {
                        minDate: new Date(),
                    },
                    RangePlugin: {
                        tooltip: false,
                        elementEnd: document.getElementById('engine-booking-end-date--activity'),
                    },
                    plugins: [LockPlugin, AmpPlugin, RangePlugin],
                })
            }

            const inputStartDateSiteTouristique = document.getElementById(
                'engine-booking-start-date--site-touristique',
            )

            if (inputStartDateSiteTouristique) {
                new easepick.create({
                    element: inputStartDateSiteTouristique,
                    css: [
                        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
                        IRISCollectionCustomer.styleCustomerEasepick,
                    ],
                    setup(picker) {
                        picker.on('select', (e) => {
                            startDate = e.detail.start.format('YYYY-MM-DD')
                            endDate = e.detail.start.format('YYYY-MM-DD')
                        })
                    },
                    inline: false,
                    calendars: 1,
                    zIndex: 12345,
                    lang: 'fr-FR',
                    AmpPlugin: {
                        resetButton: true,
                    },
                    LockPlugin: {
                        minDate: new Date(),
                    },
                    RangePlugin: {
                        tooltip: false,
                        elementEnd: document.getElementById(
                            'engine-booking-end-date--site-touristique',
                        ),
                    },
                    plugins: [LockPlugin, AmpPlugin, RangePlugin],
                })
            }
        }
    }

    static engineFormSubmit() {
        if ($("[data-element='engine-form']").length > 0) {
            $("[data-element='engine-form']").submit(function (e) {
                e.preventDefault()
                const values = {}

                $.each($(this).serializeArray(), (i, field) => {
                    values[field.name] = field.value
                })

                if (values.url) {
                    const buildUrl = `${values.url}recherche/marketplace/${values.startdate}/${values.enddate}/${values.nbperson ? `${values.nbperson}/0/` : '0/0'}`
                    window.location.href = buildUrl
                }
            })
        }
    }

    static agendaEngine() {
        const triggers = $('[data-trigger="wpiris-filter-agenda"]')

        triggers.each(function () {
            const trigger = $(this)
            const type = trigger.data('type')
            const value = `${trigger.data('val')}`
            let types = null
            let values = null

            if (type.indexOf('|') > -1) {
                types = type.split('|')
            }

            if (value.indexOf('|') > -1) {
                values = value.split('|')
            }

            trigger.click((e) => {
                e.preventDefault()

                if (types && values) {
                    $(types).each(function (i) {
                        $(`#agenda-${this}`).val(values[i])
                    })
                } else {
                    $(`#agenda-${type}`).val(value)
                }

                $('#agendaForm').submit()
            })
        })
    }

    static instaWall() {
        const social_wall = '[data-id="social-wall"]'

        if ($(social_wall).length > 0 && !$(social_wall).is(':hidden')) {
            apiFetch({
                path: IRISCollectionCustomer.irisSsoInstagramPath,
                method: 'POST',
                data: { limit: 5 },
            })
                .then((result) => {
                    $(social_wall).html(result.render)
                    import(
                        '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                    ).then(({ default: hc_lazyload }) => {
                        hc_lazyload()
                    })
                })
                .catch(() => {
                    $(social_wall).html('')
                })
        }
    }

    static rootVarHeight() {
        if (window.matchMedia('(max-width: 1000)').matches) {
            document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`)
        }
    }

    static getPreviousDay(date = new Date()) {
        const previous = new Date(date.getTime())
        previous.setDate(date.getDate() - 1)
        previous.toDateString()

        return previous
    }
}
